import { constructEnum } from '@/lib/enum';

export default constructEnum('ProductDisplayFilter', {
  ALL: 0,
  SELECTED_CATEGORY: 10,
  SELECTED_PRODUCTS: 20
});
